import { coreV1GetRuleOptions } from '@antimatterhq/asl-api-ts-v1';
import { useSuspenseQuery } from '@antimatterhq/ui/hooks/queries/useSuspenseQuery';
import { useValueWithSuspense } from '@antimatterhq/ui/hooks/suspense/useValueWithSuspense';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetRule = ({
  name,
  version,
}: {
  name: string;
  version?: number;
}) => {
  const workspaceContext = useWorkspace();
  const workspace = useValueWithSuspense(workspaceContext.workspace);

  return useSuspenseQuery({
    ...coreV1GetRuleOptions({
      ...defaultOptions(),
      path: { workspace, name },
      query: { version },
    }),
    gcTime: 0,
  });
};
